export const TARGET_TYPES = {
    general: 'General',
    account: 'Account',
    contact: 'Contact',
    project: 'Project',
};
